module.exports = __webpack_public_path__ + "img/business3.e950da68.png";